import React, { useState, useRef, useEffect } from 'react';
import { IoLocationOutline } from 'react-icons/io5';
import DynamicKakaoMapSelectContainer from './DynamicKakaoMapSelectContainer';
import { updateLocation } from '../../api/MemberApi';

const LocationSelectionContainer = ({ onLocationSaved }) => {
    const [currentLatitude, setCurrentLatitude] = useState(37.56698); // 서울시청 기본값
    const [currentLongitude, setCurrentLongitude] = useState(126.97815);
    const [isLoading, setIsLoading] = useState(false);
    const mapRef = useRef(null);

    useEffect(() => {
        getCurrentLocation();
    }, []);

    const updateMapPosition = (lat, lng) => {
        setCurrentLatitude(lat);
        setCurrentLongitude(lng);
        if (mapRef.current?.setCenter) {
            mapRef.current.setCenter(lat, lng);
        }
    };

    const getCurrentLocation = async () => {
        // Flutter WebView 환경 (JavaScriptHandler 방식)
        if (window.flutter_inappwebview?.callHandler) {
            console.log('📱 Flutter 환경에서 위치 요청');

            try {
                const result = await window.flutter_inappwebview.callHandler('getLocation');
                console.log('📍 Flutter에서 받은 위치 응답:', result);

                if (result.success) {
                    updateMapPosition(result.latitude, result.longitude);
                    console.log('✅ Flutter 위치 설정 완료:', result.latitude, result.longitude);
                } else {
                    console.warn('❌ Flutter 위치 실패:', result.error);
                }
            } catch (error) {
                console.error('❌ Flutter 위치 요청 오류:', error);
            }
            return;
        }

        // 일반 웹 브라우저 환경
        console.log('🌐 브라우저에서 위치 요청');
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(
                (pos) => {
                    updateMapPosition(pos.coords.latitude, pos.coords.longitude);
                    console.log('✅ 브라우저 위치 설정 완료:', pos.coords.latitude, pos.coords.longitude);
                },
                (err) => {
                    console.warn('❌ 브라우저 위치 실패:', err.message);
                },
                { enableHighAccuracy: true, timeout: 10000, maximumAge: 0 }
            );
        } else {
            console.warn('❌ Geolocation 미지원 브라우저');
        }
    };

    const handleSaveLocation = async () => {
        try {
            setIsLoading(true);
            const pos = mapRef.current?.getCurrentPosition() || {
                latitude: currentLatitude,
                longitude: currentLongitude
            };
            await updateLocation(pos.latitude, pos.longitude);
            if (onLocationSaved) onLocationSaved();
        } catch (error) {
            console.error('위치 저장 실패:', error);
            alert('위치 저장에 실패했습니다.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="flex flex-col h-full overflow-hidden">
            {/* 안내 메시지 */}
            <div className="flex-shrink-0 p-4 bg-amber-50 border-b border-amber-100">
                <p className="text-md text-gray-700 text-center">현재 위치를 설정해주세요</p>
                <p className="text-sm text-gray-500 text-center mt-1">
                    지도를 움직여서 정확한 위치를 선택할 수 있습니다
                </p>
            </div>

            {/* 지도 */}
            <div className="flex-1 relative overflow-hidden">
                <div className="absolute inset-4 bg-gray-100 rounded-lg overflow-hidden">
                    <DynamicKakaoMapSelectContainer
                        ref={mapRef}
                        initialLatitude={currentLatitude}
                        initialLongitude={currentLongitude}
                        className="w-full h-full"
                    />
                </div>

                {/* 현재 위치 버튼 */}
                <div className="absolute top-6 right-6 z-10">
                    <button
                        onClick={getCurrentLocation}
                        className="px-3 py-2 bg-white border border-gray-300 rounded-lg shadow-sm text-sm font-medium text-gray-700 active:bg-gray-50"
                    >
                        <div className="flex items-center space-x-1">
                            <IoLocationOutline size={16} />
                            <span>현재 위치로 재설정</span>
                        </div>
                    </button>
                </div>
            </div>

            {/* 저장 버튼 */}
            <div className="flex-shrink-0 p-4 bg-white border-t border-gray-200">
                <button
                    onClick={handleSaveLocation}
                    disabled={isLoading}
                    className={`w-full py-4 rounded-lg font-medium transition-colors ${
                        !isLoading
                            ? 'bg-amber-500 text-white active:bg-amber-600'
                            : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                    }`}
                >
                    {isLoading ? '위치 저장 중...' : '위치 저장하기'}
                </button>
            </div>
        </div>
    );
};

export default LocationSelectionContainer;
